import React, { useEffect, useRef, useState } from 'react';
import CustomFilterDropDown from '../../../ReUsableComponent/CustomFilterDropdown';
import CustomDateRangePicker from '../../../ReUsableComponent/CustomDaterangePicker';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userAuthActions } from '../../../store/reducers/UserAuthReducers';
import dropDownIcon from '../../../assets/svg/dropDownIcon.svg';
import CalendarIcon from '../../../assets/svg/calendar_2_fill.svg';
import moment from 'moment';
import { GetBrandNameList } from '../../RuleManagement/RuleManagement.service';
import { DownloadSalesDashboardReport, DownloadStoreSales, getSalesFilterValue, GetSalesYear, GetStoreSales, SendReportByEmail } from '../SalesOverview.service';
import { salesActions } from '../../../store/reducers/SalesOverviewReducer';
import Loader from '../../../ReUsableComponent/Loader';
import { BrandWiseStoreSalesHeader, storeSalesTableHeader } from '../../TableHeaders';
import CustomTableWithFilter from '../../../ReUsableComponent/CustomTableWithFilter';
import { ToastErrorService, ToastSuccessService } from '../../../ReUsableComponent/ToastNotification/ToastService';
import DownloadIcon from '../../../assets/svg/blueDownload.svg';
import { saveAs } from 'file-saver';
import CustomFilterSearchDropdown from '../../../ReUsableComponent/CustomFilterSearchDropdown';
import dayjs from 'dayjs';
import CustomPagination from '../../../ReUsableComponent/Pagination';
import SecondaryButton from '../../../ReUsableComponent/SecondaryButton';

const StoreSales = () => {
    const yearFilterValue = [{ label: 'YTD', valueToPass: '', value: 'YTD' }, { label: 'Last 3 Months', valueToPass: 3, value: 'Last 3 Months' }, { label: 'Last 6 Months', valueToPass: 6, value: 'Last 6 Months' }, { label: 'Last 1 Year', valueToPass: 12, value: 'Last 1 Year' },]
    const GapList = [{ label: '< 1 Day', value: '1', minGap: 1, maxGap: 1 }, { label: '1-7 days', value: '7', minGap: 1, maxGap: 7 }, { label: '7-15 days', value: '15', minGap: 7, maxGap: 15 }, { label: '15-30 days', value: '30', minGap: 15, maxGap: 30 }, { label: '>30 days', value: '90', minGap: 30, maxGap: 90 }]
    const today = new Date();
    today.setDate(1)
    today.setHours(-1)
    const firstDayOfMonth = new Date(today.getFullYear(), (today.getMonth()));
    const gridRef = useRef(null);

    const history = useHistory();
    const dispatch = useDispatch();
    const [calendarOpen, setCalendarOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [brandList, setBrandList] = useState([]);
    const [regionList, setRegionList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [storeList, setStoreList] = useState([]);
    const [salesYearList, setSalesYearList] = useState([]);
    const [storeSales, setStoreSales] = useState([]);
    const [anchorElForBrand, setAnchorElForBrand] = useState(null);
    const openBrandFilter = Boolean(anchorElForBrand);
    const [anchorElForRegion, setAnchorElForRegion] = useState(null);
    const openRegionFilter = Boolean(anchorElForRegion);
    const [anchorElForState, setAnchorElForState] = useState(null);
    const openStateFilter = Boolean(anchorElForState);
    const [anchorElForStore, setAnchorElForStore] = useState(null);
    const openStoreFilter = Boolean(anchorElForStore);
    const [anchorElForSales, setAnchorElForSales] = useState(null);
    const openSalesYearFilter = Boolean(anchorElForSales);
    const [selectedBrand, setSelectedBrand] = useState({ label: '', value: '' });
    const [selectedRegion, setSelectedRegion] = useState({ label: '', value: '' });
    const [selectedState, setSelectedState] = useState({ label: '', value: '' });
    const [selectedStore, setSelectedStore] = useState({ label: '', value: '' });
    const [selectedSalesYear, setSelectedSalesYear] = useState({ label: '', value: '' });
    const startDateDisplay = useSelector(state => state.sales.startDateDisplay);
    const endDateDisplay = useSelector(state => state.sales.endDateDisplay);
    const [selectedRange, setSelectedRange] = useState([firstDayOfMonth,]);
    const [startDate, setStartDate] = useState(useSelector(state => state.sales.startDate));
    const [endDate, setEndDate] = useState(useSelector(state => state.sales.endDate));
    const [defaultYear, setdefaultYear] = useState({ label: 'YTD', value: 'YTD' });
    const [gap, setGap] = useState({
        label: '', value: '',
    });
    // const defaultYear = useSelector(state => state.sales.defaultYear);
    const defaultBrand = useSelector(state => state.sales.defaultBrand);
    const [activeTabBtn, setActiveTabBtn] = useState(1);
    const [performingBtn, setPerformingBtn] = useState(1);
    const [brandWiseSaleData, setBrandWiseSaleData] = useState([]);
    const USER_TOKEN = useSelector((state) => state.userAuthentication.userToken);
    const [dropSearchValue, setdropSearchValue] = React.useState({ brand: '', region: '', state: '', store: '' });
    const USER_ID = useSelector((state) => state.userAuthentication.userId);
    const [selectedPage, setSelectedPage] = useState(1);
    const [selectedRows, setSelectedRows] = useState([]);
    const handleSearchChange = (event, name) => {
        if (name === 'brand') setdropSearchValue(prev => ({ ...prev, brand: event.target.value }));
        else if (name === 'region') setdropSearchValue(prev => ({ ...prev, region: event.target.value }));
        else if (name === 'state') setdropSearchValue(prev => ({ ...prev, state: event.target.value }));
        else if (name === 'store') setdropSearchValue(prev => ({ ...prev, store: event.target.value }));
    };

    const tableFilter = useSelector(state => state.sales.tableFilters)

    useEffect(() => {
        dispatch(userAuthActions.setHeaderName({ type: 'Sales Overview' }));
        getAllBrand();
        getSalesYearList();
    }, [])

    useEffect(() => {
        if (defaultBrand.value !== '') getRegionStateStore(defaultBrand.value, selectedRegion.value, selectedState.value);
    }, [defaultBrand, selectedRegion, selectedState])

    useEffect(() => {
        let store = tableFilter?.nameStore ? tableFilter?.nameStore?.filter : ''
        if (defaultBrand.value) {
            getDashboardDetails(defaultYear.value, defaultBrand.value, '', '', selectedRegion.value, selectedState.value, store, gap.minGap, gap.maxGap);
        }

    }, [defaultYear, defaultBrand, selectedRegion, selectedState, selectedPage, endDate, tableFilter, gap])

    const handleBrandClick = (event) => {
        setAnchorElForBrand(event.currentTarget);
    };
    const handleBrandClose = () => {
        setAnchorElForBrand(null);
    };
    const handleRegionClick = (event) => {
        setAnchorElForRegion(event.currentTarget);
    };
    const handleRegionClose = () => {
        setAnchorElForRegion(null);
    };
    const handleStateClick = (event) => {
        setAnchorElForState(event.currentTarget);
    };
    const handleStateClose = () => {
        setAnchorElForState(null);
    };

    const handleSalesClick = (event) => {
        setAnchorElForSales(event.currentTarget);
    };
    const handleSalesClose = () => {
        setAnchorElForSales(null);
    };

    const onSelectBrand = (event) => {
        brandList.forEach(brand => {
            if (event.target.value === brand?.value) {
                setSelectedBrand({ label: brand?.label, value: event.target.value })
                setAnchorElForBrand(null);
                dispatch(salesActions.setDefaultBrand({ type: { label: brand?.label, value: event.target.value } }));
            }
        });
        setSelectedState({ label: '', value: '' })
        setSelectedStore({ label: '', value: '' })
        setSelectedRegion({ label: '', value: '' })
    }
    const onSelectRegion = (event) => {
        regionList.forEach(region => {
            if (event.target.value === region?.value) {
                setSelectedRegion({ label: region?.label, value: event.target.value })
                setAnchorElForRegion(null);
            }
        });
        setSelectedState({ label: '', value: '' })
        setSelectedStore({ label: '', value: '' })
        // dispatch(salesActions.setDefaultBrand({ type: event.target.value }));
    }
    const onSelectState = (event) => {
        stateList.forEach(state => {
            if (event.target.value === state?.value) {
                setSelectedState({ label: state?.label, value: event.target.value })
                setAnchorElForState(null);
            }
        });
        setSelectedStore({ label: '', value: '' })
        // dispatch(salesActions.setDefaultBrand({ type: event.target.value }));
    }

    function getPreviousMonthRange(months, referenceDate = new Date()) {
        if (months <= 0) {
            throw new Error("The number of months must be greater than 0");
        }
        const refDate = new Date(referenceDate);
        const endDate = new Date(refDate);
        const startDate = new Date(
            refDate.getFullYear(),
            refDate.getMonth() - (months - 1),
            1
        );

        return {
            startDate: startDate,
            endDate: endDate
        };
    }

    const onFilterChanged = (event) => {
        dispatch(salesActions.setTableFilters({ type: event.api.getFilterModel() }));
    };

    const onSelectSalesYear = (event) => {
        const selectedGapValue = GapList.find(option => option.value === event.target.value)
        setGap(selectedGapValue)
        setAnchorElForSales(null);
    }

    const getAllBrand = () => {
        // setLoading(true);
        let param = `?user_id=${USER_ID}`
        GetBrandNameList(param, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                let brands = []
                response.data.data.forEach(element => {
                    let brandObject = {
                        label: element.brand_name,
                        value: element._id
                    }
                    brands.push(brandObject)
                });
                if (!defaultBrand.value) dispatch(salesActions.setDefaultBrand({ type: { label: brands[0]?.label, value: brands[0]?.value } }));
                setBrandList(brands);
                setSelectedBrand({ label: brands[0]?.label, value: brands[0]?.value });
            }
        }).catch(error => {
            if (error.response.status === 401) {
                history.push('/')
            }
            ToastErrorService(error.response.data.message);
        }).finally(() => {
            // setLoading(false);
        })
    }

    const checkStoreName = (storeName, storeTradeName) => {
        if (storeTradeName && storeTradeName !== 'null') {
            return storeTradeName
        } else {
            return storeName
        }
    }

    const handlePageChange = (event) => {
        setSelectedPage(event.target.value)
    }

    const getRegionStateStore = (brand, region, state) => {
        // setLoading(true);
        let param = `?store_region=${region}&store_state=${state}&brand_id=${brand}`
        getSalesFilterValue(param, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                let store = []
                response.data.data.store.forEach(element => {
                    let storeObject = {
                        label: checkStoreName(element.store_name, element.store_trade_name),
                        value: element.store_id
                    }
                    store.push(storeObject)
                });
                setStoreList(store);

                let regions = []
                response.data.data.region.forEach(element => {
                    let regionObj = {
                        label: element.store_region,
                        value: element.store_region
                    }
                    regions.push(regionObj)
                });
                setRegionList(regions);

                let states = []
                response.data.data.state.forEach(element => {
                    let stateObj = {
                        label: element.store_state,
                        value: element.store_state
                    }
                    states.push(stateObj)
                });
                setStateList(states)
            }
        }).catch(error => {
            if (error?.response?.status === 401) {
                history.push('/')
            }
            ToastErrorService(error?.response?.data?.message);
        }).finally(() => {
        })
    }

    const onClickDownload = () => {
        downloadSalesReport('', defaultBrand?.value, gap.minGap, gap.maxGap, selectedRegion.value, selectedState.value);
    }

    const convertDate = (openingDate) => {
        let date = new Date(openingDate);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let dateString = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;

        return moment(dateString).format("DD MMM YYYY");
    }

    const convertDateStringToObj = (dateString) => {
        const dateInIST = moment.tz(dateString, 'Asia/Kolkata');
        const finalFormattedDate = new Date(dateInIST.format());
        return finalFormattedDate
    }

    const getSalesYearList = () => {
        GetSalesYear(USER_TOKEN).then(response => {
            let salesYear = []
            response.data.data.forEach(element => {
                let salesObj = {
                    label: element,
                    value: element
                }
                salesYear.push(salesObj)
            });
            salesYear.push({ label: 'Custom', value: '' });
            setSalesYearList(salesYear);
            if (!defaultYear.label) {
                dispatch(salesActions.setDefaultYear({ type: { label: salesYear.at(-2)?.label, value: salesYear.at(-2)?.value } }));
                setSelectedSalesYear({ label: salesYear.at(-2)?.label, value: salesYear.at(-2)?.value });
                dispatch(salesActions.setStartDateDisplay({ type: null }));
                dispatch(salesActions.setEndDateDisplay({ type: null }));
                dispatch(salesActions.setStartDate({ type: null }));
                dispatch(salesActions.setEndDate({ type: null }));
            }
        }).catch(error => {
            if (error.response.status === 401) {
                history.push('/')
            }
            ToastErrorService(error.response.data.message);
        }).finally(() => {

        })
    }

    const downloadSalesReport = (range, brand, minGap, maxGap, region, state) => {
        setLoading(true);
        let param = `?brand_id=${brand}&store_region=${region}&store_state=${state}&gap_in_days_min=${minGap}&gap_in_days_max=${maxGap}`;
        DownloadStoreSales(param, USER_TOKEN).then(response => {
            const responseInUnit = new Uint8Array(response.data.buffer.data);
            const blob = new Blob([responseInUnit], { type: 'application/octet-stream' });
            saveAs(blob, response.data.filename);
            if (response?.data?.buffer?.statusCode === 400) {
                ToastErrorService(response?.data?.buffer?.message);
            } else {
                ToastSuccessService('Report downloaded successfully.');
            }
        }).catch(error => {
            ToastErrorService(error?.response?.data?.message)
        }).finally(() => {
            setLoading(false);
        })
    }

    const storeTradeNameCheck = (store, tradeName) => {
        if (tradeName && tradeName !== 'null') {
            return tradeName
        } else {
            return store
        }
    }
    const getAchievementPercent = (target, achieved) => {
        if (target && achieved) {
            let value = (achieved / target) * 100
            return Math.round(value)
        } else {
            return 0;
        }
    }
    const getDashboardDetails = (range, brand, startdate, enddate, region, state, storeName, minGap, maxGap) => {
        setLoading(true);
        let param = `?brand_id=${brand}&store_region=${region}&store_state=${state}` + `${storeName ? '&store_name=' + storeName : ''}${minGap ? `&gap_in_days_min=${minGap}` : ''}${maxGap ? `&gap_in_days_max=${maxGap}` : ''}`;
        GetStoreSales(param, USER_TOKEN).then(response => {
            setStoreSales(response.data.data)
            let dataForBrandWiseSale = [];
            response.data.data.forEach((item, index) => {
                let row = {
                    nameStore: storeTradeNameCheck(item.store_name, item.store_trade_name),
                    gap: item.gap_in_days,
                    invDate: convertDate(item?.invoice_date),
                    lastUpdated: convertDate(item?.updated_at === null ? item?.created_at : item?.created_at),
                    id: item?.store_id,
                    createdDate: item?.created_at,
                    updated: item?.updated_at,
                    invoiceDate: item?.invoice_date,
                    tradeName: item?.store_trade_name
                }
                dataForBrandWiseSale.push(row);
            })
            setBrandWiseSaleData([...dataForBrandWiseSale]);
        }).catch(error => {
            if (error?.response?.status === 401) {
                history.push('/')
            }
            ToastErrorService(error?.response?.data?.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    const valueCheck = (value) => {
        if ((value && value !== 'null')) {
            return value;
        } else {
            return '-';
        }
    }


    const getRowStyle = (params) => {
        if (params.data.totalRow) {
            return { fontWeight: 'bold', backgroundColor: '#f0f0f0' };
        }
        return null;
    };

    function transformSalesLabels(input) {
        const labels = activeTabBtn === 1 ? input.map(item => item.category) : input.map(item => item.product);
        return labels;
    }

    function transformSalesData(input) {
        const data = input.map(item => Number(item.grossSales.replace(/₹|,/g, "")));
        return data;
    }

    const onClickTabBtn = (value) => {
        setActiveTabBtn(value);
        setPerformingBtn(1);
    }
    const onClickPerforming = (value) => {
        setPerformingBtn(value)
    }

    const onGridReady = (params) => {
        gridRef.current = params.api;
        gridRef.current.sizeColumnsToFit();
    };

    const onSelectionChanged = (params) => {
        const selectedNodes = params.api.getSelectedNodes(); // Get selected nodes
        const selectedData = selectedNodes.map(node => node.data); // Get selected rows' data
        setSelectedRows(selectedData);
    };

    const onClickClear = (filter) => {
        if (filter === 'state') {
            setSelectedState({ label: '', value: '' });
            handleStateClose();
        } else if (filter === 'gap') {
            setGap({ label: '', value: '' });
            handleSalesClose();
        } else {
            setSelectedRegion({ label: '', value: '' });
            handleRegionClose();
        }
    }

    const onClickSendEmail = () => {
        setLoading(true);
        let reqBody = {
            stores_info: []
        }
        selectedRows.forEach(item => {
            let store = {
                "store_name": item?.nameStore,
                "store_trade_name": item?.tradeName,
                "invoice_date": item.invoiceDate,
                "created_at": item.createdDate,
                "updated_at": item.updated,
                "store_id": item?.id,
                "gap_in_days": item.gap
            }
            reqBody.stores_info.push(store)
        })
        SendReportByEmail(reqBody, USER_TOKEN).then(response => {
            ToastSuccessService('Email sent successfully.', 1)
        }).catch(error => {
            ToastErrorService(error?.response?.data?.message)
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <div className='main-container'>

            <div>
                <div className='d-flex justify-content-between filter-cont '>
                    <div className='d-flex align-items-center first-filter '>
                        {/* <div className='goToMasterBtn me-3' onClick={onClickGotoReports}>Go to Reports</div> */}
                        {/* brand filter */}
                        <div className='position-relative min-w-150'>
                            <div className='d-flex statusFilter cursorPointer align-items-center justify-content-between me-3'
                                onClick={handleBrandClick}>
                                <p className='text-truncate' title={defaultBrand.label}>{defaultBrand?.label}</p>
                                <img className={`${openBrandFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                            </div>
                            <CustomFilterSearchDropdown data={brandList} handleClose={handleBrandClose} open={openBrandFilter} anchorEl={anchorElForBrand}
                                onChange={onSelectBrand} selectedValue={defaultBrand?.value} category={'Brand'}
                                dropSearchValue={dropSearchValue.brand} handleSearchChange={(e) => handleSearchChange(e, 'brand')} setdropSearchValue={setdropSearchValue} />
                        </div>
                        {/* region filter  */}
                        <div className='position-relative min-w-150'>
                            <div className='d-flex statusFilter cursorPointer align-items-center justify-content-between me-3'
                                onClick={handleRegionClick}>
                                <p className='text-truncate' title={selectedRegion.label}>{selectedRegion?.label === '' ? 'Select Region' : selectedRegion?.label}</p>
                                <img className={`${openRegionFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                            </div>
                            <CustomFilterSearchDropdown onClickClear={() => onClickClear('Region')} data={regionList} handleClose={handleRegionClose} open={openRegionFilter} anchorEl={anchorElForRegion}
                                onChange={onSelectRegion} selectedValue={selectedRegion?.value} category={'Region'}
                                dropSearchValue={dropSearchValue.region} handleSearchChange={(e) => handleSearchChange(e, 'region')} setdropSearchValue={setdropSearchValue} />
                        </div>
                        {/* state filter  */}
                        <div className='position-relative min-w-150'>
                            <div className='d-flex statusFilter cursorPointer align-items-center justify-content-between me-3'
                                onClick={handleStateClick}>
                                <p className='text-truncate' title={selectedState.label}>{selectedState?.label === '' ? 'Select State' : selectedState?.label}</p>
                                <img className={`${openStateFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                            </div>
                            <CustomFilterSearchDropdown onClickClear={() => onClickClear('state')} data={stateList} handleClose={handleStateClose} open={openStateFilter} anchorEl={anchorElForState}
                                onChange={onSelectState} selectedValue={selectedState?.value} category={'Brand'}
                                dropSearchValue={dropSearchValue.state} handleSearchChange={(e) => handleSearchChange(e, 'state')} setdropSearchValue={setdropSearchValue} />
                        </div>
                    </div>
                    <div className='d-flex align-items-center'>
                        <div className='position-relative min-w-150'>
                            <div className='d-flex statusFilter cursorPointer align-items-center justify-content-between me-3'
                                onClick={handleSalesClick}>
                                <p className='text-truncate' title={gap.label}>{gap?.label === '' ? 'Select Gap' : gap?.label}</p>
                                <img className={`${openSalesYearFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                            </div>
                            <CustomFilterDropDown onClickClear={() => onClickClear('gap')} data={GapList} handleClose={handleSalesClose} open={openSalesYearFilter} anchorEl={anchorElForSales}
                                onChange={(e) => onSelectSalesYear(e)} selectedValue={gap?.value} category={'Gap'} />
                        </div>
                    </div>
                </div>
            </div>

            <div className='brand-wise-sale'>
                <div className='d-flex justify-content-between'>
                    <div className='montserratFont fontSize18'>
                        {'Store'} Sales
                    </div>

                    <div className='d-flex align-items-center'>
                        <div className='me-2'>
                            <SecondaryButton customClsName='resetBtn' title={'Send Email'} onClick={onClickSendEmail} />
                        </div>                        <button className='download-btn' onClick={onClickDownload}>
                            <img src={DownloadIcon} width={24} height={24} alt="" />
                        </button>
                    </div>
                </div>
                <div className='paddingTop16'>
                    <CustomTableWithFilter height={'calc(100vh - 360px)'} isContentLeftRightFixed={true} onFilterChanged={onFilterChanged} totalRow={() => { }} onSelectionChanged={onSelectionChanged} getRowStyle={getRowStyle} column={storeSalesTableHeader} totalValues={''} tableRowData={brandWiseSaleData} onGridReady={onGridReady} />
                </div>
                {/* <div className='paddingTop16 d-flex justify-content-end customPagination'>
                    <CustomPagination onClick={handlePageChange} activePage={selectedPage} pageSize={20} currentPage={selectedPage} totalItems={brandWiseSaleData?.length} />
                </div> */}
            </div>
            {loading && <Loader />}
        </div>
    )
}
export default StoreSales
